import * as yup from 'yup';

export const isOverridden = <T extends object>(
  value: yup.ObjectSchema<T>,
  required: boolean = true
) => {
  const schema = value.concat(
    yup.object({ isOverridden: yup.boolean().required() })
  );

  if (required) {
    return schema.required();
  }

  return schema;
};
